export default __webpack_public_path__ + "static/media/orangered.7947ed20.png";